import { useNavigate } from 'react-router-dom';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import Tooltip from '@mui/material/Tooltip';
import IconButton from 'components/@extended/IconButton';
const LogoutButton = () => {
  const navigate = useNavigate();

  const logOutUser = () => {
    localStorage.removeItem('data');
    localStorage.removeItem('jwtToken');
    sessionStorage.removeItem('data');
    sessionStorage.removeItem('jwtToken');
    navigate('/login');
  };

  return (
 
       <IconButton size="large" sx={{ color: 'text.primary' }} onClick={logOutUser}>
        <LogoutOutlined />
      </IconButton>
   
  );
};

export default LogoutButton